import styled from 'styled-components';
import photoHeader from 'assets/images/photo-header.jpg';
import { fonts } from 'styles';

export const Container = styled.header`
  width: 100%;
  height: 100vh;
  background: url(${photoHeader}) no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
`;
